import { React, Fragment, useState, useRef } from "react";
import Masonry from 'react-smart-masonry';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from '@headlessui/react';
import SingleCard from "../../shades/cards/singleCard";
// import SingleBucket from "../SingleBucket";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "moment";
import './sharedwithme.scss'
// import {ReactComponent as CalenderIcon} from "../../assets/icons/calendarIcon.svg";

import { useOutletContext } from "react-router-dom";
import CreateBucket from "../../shades/CreateBucket";

import DeleteIcon from '../../assets/icons/delete.svg';



import ThreeDots from '../../assets/icons/threeDots.svg';
import Arrow from '../../assets/icons/arrow.svg';

import SortMbl from '../../assets/icons/sortmbl.svg';
import { toastify } from '../../components/Toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import "../../shades/cards/shareCard";

const breakpoints = { mobile: 0, tablet: 900, desktop: 1200 };
function SharredCards() {
  useRef();
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);

  // const [userList, setUserList] = useState([]);
  const [lastList, setLastList] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  useState([]);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [bucketCreated, setBucketCreated] = useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  const [bucketOperation, ] = useState('Add');
  const [selectedItems, setSelectedItems] = useState([]);
  useState(false);
  let [isOpenss, setIsOpens] = useState(false);
  useOutletContext();
  const [buckets, setBuckets] = useState([]);
  const [clickedCardId, setClickedCardId] = useState(null);
  const [, setTotalCards] = useState(0);
  const [, setBucketSharePopup] = useState(false)
  const [, setShareBucketId] = useState('')
  const [, setSharedBuckets] = useState(false)
  const [SharedToken, setSharedToken] = useState(false)
  const [, setSharedUsers] = useState([])
  useState('');
  const bucketId = useParams();
  useEffect(() => {
    setSharedToken(true)
  }, [])



  function closeCardModal() {
    // setSelectedItems([]);
    setIsOpens(false);
  }

  const handleSharePop = (id) => {
    setShareBucketId(id)
    setBucketSharePopup(true)
  }
  const filterDropDown = [
    { name: 'Created Date', href: '#' },
    { name: 'Recent Activity', href: '#' },
    { name: 'Ascending Order', href: '#' },
    { name: 'Descending Order', href: '#' },
    // { name: 'Manual', href: '#' },
  ]

  let cardFilterv = '';
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem('cardFilter', 'Created_Date');
    cardFilterv = 'Created_Date';
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [, setCardFilterDefault] = useState(cardFilterv);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem('token');
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}buckets/user-buckets`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  useEffect(() => {
    // api url
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      setIsLoadings(true);
      await axios.get(`${process.env.REACT_APP_API}team/shared-withMe-items`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
        .then(function (response) {
          setIsLoading(false);
          // if (!response.data.data.cardsList.length) {
          //   setLastList(true);
          //   setIsLoadings(false);
          //   return;
          // }
          setPrevPage(currPage);
          if (response.data.data.cardsList && response.data.data.bucketList.length) {
            setSharedToken(true)
            setSharedUsers(response?.data?.data?.bucketList?.shared)
          }
          // setUserList([...userList, ...response.data.data]);
          setCardList(response.data.data.cardsList);
          setTotalCards(response.data.data.cardsList.length);
          setSharedBuckets(true)
          setIsLoadings(false);
          // setCardList(response.data.data);
          // setBucketList(response.data.data.bucketList);
          // setTotalBuckets(response.data.data.total);
          // reorder(response.data.data.slice(0,response.data.data.length),4);
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      if (parseInt(scrollTop) + parseInt(clientHeight) === parseInt(scrollHeight)) {
        setCurrPage(currPage + 1);
      }
    };

    if (!lastList && prevPage !== currPage) {
      fetchData();
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, [bucketCreated, cardCreated, currPage, lastList, prevPage, cardList, isLoadings])
  const handleCardClick = (cardId) => {
    setClickedCardId(cardId);
  };
  useEffect(() => {
  }, [clickedCardId])




  // const [filtersText, setFiltersText] = useState(filterDropDown[0].name);
  const [, setFiltersText] = useState((cardFilterv === 'Created_Date') ? filterDropDown[0].name : (
    cardFilterv === 'Descending_Order' ? filterDropDown[3].name : (
      cardFilterv === 'Ascending_Order' ? filterDropDown[2].name : (
        cardFilterv === 'Recent_Activity' ? filterDropDown[1].name : ""
      )
    )
  ));

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };

  const deleteCard = async () => {
    setIsOpens(true);
  };

  const handleDeleteCard = async () => {
    setIsLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      closeCardModal();
      cardUpdate();
    } catch (error) {
      console.error(error);
      closeCardModal();
      setIsLoading(false);
      toastify("error", error.response.data.message);
    }
  }

  const handleFilterText = async (text) => {
    // setFiltersText(text);
    setIsLoading(true);
    setFiltersText(text);
    const filterValues = (text === 'Created Date') ? "Created_Date" : (
      text === 'Descending Order' ? "Descending_Order" : (
        text === 'Ascending Order' ? "Ascending_Order" : (
          text === 'Recent Activity' ? "Recent_Activity" : ""
        )
      )
    );
    localStorage.setItem('cardFilter', filterValues);
    setCardFilterDefault(filterValues);
    localStorage.getItem('token');
    cardUpdate();
  }
  const bucketNav = [
    { icon: faPencil, name: 'Edit Name', href: '#' },
    // {icon:faNoteSticky, name: 'Create New Card', href: '#' },
    { icon: faTrash, name: 'Delete', href: '#' },
    // {icon:faFolder, name: 'Customize New Card', href: '#' },
  ]








  function cardUpdate() {
    // setBucketCreated(true);
    setLastList(false);
    setCurrPage(1);
    setPrevPage(0);
    setCardList([]);
    setCardCreated(!cardCreated);
  }

  function bucketUpdate() {
    // setBucketCreated(true);
    setBucketCreated(!bucketCreated);
  }



  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <>
      {
        isLoading ? (
          <div className='App-loading'>
            <div className='App-logo' title='Zimzee' />
          </div>
        )
          :
          (
            <div className="bucketDashboardsection listingCards">
              <div className="cards">
                {/* <div className="subbucketheaderdesktop-section">
               <div className="cards-filter cardsspacing-content flex justify-between">
                    <div className="flex items-center">
                        <div className="card-count flex items-center">
                            <h4 className="cardssubBuckets-content">Cards</h4><span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">{totalCards}</span>
                        </div>
                        {BucketSharePopup &&
             <div className="filesuploadpopup relative !z-[999]" style={{ height: "100%" }} onClick={closeSharePop}>
             <div className="subinviteupload-section" onClick={(e)=>e.stopPropagation()}>
               <div className="teaminvitesection flex">
                 <div className="teammembers-content">Share</div>
                 <div className="dismissSubfiles-content" onClick={closeSharePop}><img src={BlackDismiss} alt="dismissButton" /></div>
               </div>
             <ShareCard shareBucketId={shareBucketId} closeSharePop={closeSharePop}  />
             </div>
             </div>

             }
                        <Menu as="div" className="relative px-2">
                            <Menu.Button
                                className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 "
                            >

                                <img src={ThreeDots} alt="threeDots" />
                            </Menu.Button>
                            <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    {bucketNav.map((item) => (
                                        <Menu.Item key={item.name}>
                                        {({ active }) => (
                                            <a
                                            href={item.href}
                                            className={classNames(
                                                active ? 'bg-gray-100' : '',
                                                'block py-2 px-4 text-sm text-gray-700'
                                            )}
                                            >
                                                <span className="pr-2"><FontAwesomeIcon className="text-[#797979]" icon={item.icon} /></span>
                                            <span className="text-black">{item.name}</span>
                                            </a>
                                        )}
                                        </Menu.Item>
                                    ))}
                                    </Menu.Items>
                                </Transition>
                        </Menu>
                        <img src={DeleteIcon} alt="deleteIcon" className="px-3" onClick={()=>deleteCard()}/>
                        <Transition appear show={isOpenss} as={Fragment}>
                          <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <div className="fixed inset-0 bg-black bg-opacity-25" />
                            </Transition.Child>

                            <div className="fixed inset-0 overflow-y-auto">
                              <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0 scale-95"
                                  enterTo="opacity-100 scale-100" 
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100 scale-100"
                                  leaveTo="opacity-0 scale-95"
                                >
                                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                                    <Dialog.Title
                                      as="h3"
                                      className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                      Delete
                                    </Dialog.Title>
                                    <div className="mt-2">
                                      <p className="text-sm text-gray-500">
                                        Are you sure you want to delete?
                                      </p>
                                    </div>

                                    <div className="mt-4">
                                      <button style={{background:'#FF6600',width:"80px",color:"#fff",padding:"10px",borderRadius:"50px"}}
                                        type="button"
                                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                        onClick={() => handleDeleteCard()}
                                      >
                                        Yes
                                      </button>
                                      <button style={{background:'#000',width:"80px",color:"#fff",padding:"10px",borderRadius:"50px"}}
                                        type="button"
                                        className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                        onClick={closeCardModal}
                                      >
                                        No
                                      </button>
                                    </div>
                                  </Dialog.Panel>
                                </Transition.Child>
                              </div>
                            </div>
                          </Dialog>
                        </Transition>

                        <img src={Arrow} alt="arrow" className="px-3" />
                    </div>
                    <div className="filterHolder flex items-center justify-end">

                        <Menu as="div" className="relative flex-shrink-0">
                          <div>
                            <Menu.Button className="flex rounded-full focus:outline-none ">
                                  <a
                                    href="#"
                                    className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                                  >
                                  <strong className="createdtext-content pr-4">{filtersText}</strong>
                                  <FontAwesomeIcon style={{fontSize:'12px',color:'#707070'}} icon={faChevronDown} />
                              </a>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">

                              {filterDropDown.map((item) => (
                                <Menu.Item key={item.name}>
                                  {({ active }) => (

                                    <a
                                      onClick={()=>{handleFilterText(item.name)}}
                                      href={item.href}
                                      className={classNames(
                                        active ? 'bg-gray-100' : '',
                                        'block py-2 px-4 text-sm text-gray-700'
                                      )}
                                    >
                                      {item.name}
                                    </a>
                                  )}
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                    </div>
                </div>
              </div> */}
                <div className="compactdesktop-section">
                  <div style={{ marginBottom: "30px" }}>
                    <div className="grid grid-cols-3">
                      <div className="bucketFeature col-span-2">
                        <div className="flex items-center">
                          <h2 className="text-xl subbucketstext-content dark:text-[#fff]">Shared Cards</h2>
                          <p className="total-bucktes ml-4 rounded-full  right-0 mr-2 text-white bg-[#FF6600] ml-3 inline-block rounded-full py-0.5 text-xs font-medium w-8 h-6 flex justify-center items-center menuCount">{cardList?.length}</p>
                          {/* <button style={{filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))'}} onClick={handlePopup} className="buttonpadding-content mx-8 text-[16px] rounded-full bg-[#FF6600] text-white pr-[32px]">
                                <FontAwesomeIcon className="pl-[23px] pr-[17.73px]" icon={fontIcons.faPlus} />
                                    <span className="createbutton-context">Create New</span>
                                    </button>  */}
                        </div>
                        {/* <div className="totalbucket-content"><img className="bucket-imgcontent" src={BucketIcon} alt="bucketIcon"/>{totalBuckets} Buckets in Total</div>         */}
                      </div>
                      {/* <div className="filterHolder flex items-center justify-end">
                              <img onClick={handleRectangle} className="icon-imgcontent compact-view w-5" src={Compacticongrey} alt="compacticonGrey" />

                              <img onClick={handleSquare} className="icon-imgcontent regular-view w-5" src={NormaliconBlack} alt="normaliconBlack" />
                            <span className="sorttext-content">Sort By</span>
                            <Menu as="div" className="relative flex-shrink-0">
                              <div>
                                <Menu.Button className="flex rounded-full dark:text-[#acacac] focus:outline-none">
                                      <a
                                        href="#"
                                        className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 "
                                      >
                                      <strong className="createdtext-content pr-4">{filtersText}</strong>
                                      <FontAwesomeIcon style={{fontSize:'12px',color:'#707070'}} icon={fontIcons.faChevronDown} />

                                  </a>
                                </Menu.Button>
                              </div>
                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className="filter-dropdown absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">

                                  {filterDropDown.map((item) => (
                                    <Menu.Item key={item.name}>
                                      {({ active }) => (

                                        <a
                                          onClick={()=>{handleFilterText(item.name)}}
                                          href={item.href}
                                          className={classNames(
                                            active ? 'bg-gray-100' : '',
                                            'block py-2 px-4 text-sm text-gray-700'
                                          )}
                                        >
                                          {item.name}
                                        </a>
                                      )}
                                    </Menu.Item>
                                  ))}
                                </Menu.Items>
                              </Transition>
                            </Menu>
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className="subbucketheadermbl-section">
                  <div className="cards-filter cardsspacing-content flex justify-between">
                    <div className="flex items-center">
                      <div className="card-count flex items-center">
                        <h4 className="cardssubBuckets-content">Cards</h4><span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">{cardList?.length}</span>
                      </div>
                      <Menu as="div" className="relative px-2">
                        <Menu.Button
                          className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 "
                        >
                          {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                          <img src={ThreeDots} alt="threeDots" />
                        </Menu.Button>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {bucketNav.map((item) => (
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <a
                                    href={item.href}
                                    className={classNames(
                                      active ? 'bg-gray-100' : '',
                                      'block py-2 px-4 text-sm text-gray-700'
                                    )}
                                  >
                                    <span className="pr-2"><FontAwesomeIcon className="text-[#797979]" icon={item.icon} /></span>
                                    <span className="text-black">{item.name}</span>
                                  </a>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>

                      <img src={DeleteIcon} alt="deleteIcon" className="px-3" onClick={() => deleteCard()} />
                      <Transition appear show={isOpenss} as={Fragment}>
                        <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                          </Transition.Child>

                          <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                              <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                              >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                                  <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                  >
                                    Delete
                                  </Dialog.Title>
                                  <div className="mt-2">
                                    <p className="text-sm text-gray-500">
                                      Are you sure you want to delete?
                                    </p>
                                  </div>

                                  <div className="mt-4">
                                    <button style={{ background: '#FF6600', width: "80px", color: "#fff", padding: "10px", borderRadius: "50px" }}
                                      type="button"
                                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                      onClick={() => handleDeleteCard()}
                                    >
                                      Yes
                                    </button>
                                    <button style={{ background: '#000', width: "80px", color: "#fff", padding: "10px", borderRadius: "50px" }}
                                      type="button"
                                      className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                      onClick={closeCardModal}
                                    >
                                      No
                                    </button>
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </Dialog>
                      </Transition>
                      {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
                      <img src={Arrow} alt="arrow" className="px-3" />
                    </div>
                    <div className="filterHolder flex items-center justify-end">
                      {/* <div className="filter display-content">  
                            <a className="viewGrid" href={getUrl('list')}>                            
                             <img className="mt-1 listcard-imgcontent" src={ListView} alt="listView" />
                            </a>
                            <a className="viewGrid" href={getUrl('grid')}>                            
                             <img className="mt-1 compact-imgcontent" src={compactCardIcon} style={{color:'#000000'}} alt="compactIcon" />
                            </a>
                        </div> */}

                      {/* <span className="sorttext-content mx-3 dark:text-[#acacac]">Sort By</span> */}
                      <div>
                        <Menu as="div" className="sortmbl-content relative flex-shrink-0">
                          <div>
                            <Menu.Button className="flex rounded-full dark:text-[#acacac] focus:outline-none">
                              <span data-former-link=""

                                className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 "
                              >

                                <img className="sortmbl-imgcontent" src={SortMbl} alt="SortMbl" />

                              </span>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">

                              {filterDropDown.map((item) => (
                                <Menu.Item key={item.name}>
                                  {({ active }) => (

                                    <a
                                      onClick={() => { handleFilterText(item.name) }}
                                      href={item.href}
                                      className={classNames(
                                        active ? 'bg-gray-100' : '',
                                        'block py-2 px-4 text-sm text-gray-700'
                                      )}
                                    >
                                      {item.name}
                                    </a>
                                  )}
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/* Single Card */}
              <div className="mansorydesktop-section">
                <Masonry breakpoints={breakpoints}
                  columns={{ mobile: 1, tablet: 3, desktop: 4 }}
                  gap={{ mobile: 20, tablet: 15, desktop: 15 }}
                  style={{ display: "flex" }}
                >
                  {/* <div 
        onScroll={onScroll}
        ref={listInnerRef}
        // style={{ height: "100vh", overflowY: "auto" }}
      > */}
                  {cardList?.map((card) => {
                    const userData = JSON.parse(localStorage.getItem('userData'));
                    const matchingBucket = card?.shared && card?.shared.find(user => user?._id === userData?._id);
                    return <SingleCard key={card._id} SharedToken={SharedToken} sharedUsers={card?.shared} sharedBy={card?.sharedBy?.fullName} shared={card?.shared} PermissionState={matchingBucket?.permissions} handleSharePop={handleSharePop} starred={card.starred} buckets={buckets} cardUpdate={cardUpdate} cardId={card._id} cardType={card.cardType} sharedLength={card.shared.length} title={card.title} content={card.content} note={card.note} tags={card.tags} postDetail={card.postDetail ? card.postDetail : ""} updated={card.updatedAt} handleCheckboxChange={handleCheckboxChange} handleCardClick={handleCardClick} />
                  })}
                  {/* </div> */}

                </Masonry>
              </div>
              {/* {isLoadings && (
                <Masonry breakpoints={breakpoints}
                columns={{ mobile: 2, tablet: 3, desktop: 4 }}
                gap={{ mobile: 20, tablet: 15, desktop: 15 }}>
                    <div className="cardHolder rounded-[14px] overflow-hidden break-inside" style={{height:"330px"}}>
                      <div className="cardheight-content">
                            <div className="flex justify-between w-full px-3 pt-3">
                              <div className="inputCheck">
                                  <input type="checkbox"/>
                              </div>
                              <div className="flex">
                                <Skeleton />
                              </div>
                          </div>
                          <div className="cardHeader flex items-center pb-1 px-3">
                              <div className="logo w-[30px] rounded">
                                    <Skeleton />
                              </div>
                              <div className="Cardtitle w-3/4 pl-3">
                              <Skeleton />
                              </div>
                              <div className="iconsRight flex items-center">
                              <Skeleton />
                              </div>
                          </div>
                          <p></p>
                          <div className="cardContent cardListContent w-full">
                          <Skeleton />
                            </div>
                        </div>
                        <div className="px-3">
                        <Skeleton />
                          </div>
                          <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                          <Skeleton />
                            </div>
                            <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                            <Skeleton />
                              </div>
                      </div>
                      <div className="cardHolder rounded-[14px] overflow-hidden break-inside" style={{height:"330px"}}>
                        <div className="cardheight-content">
                              <div className="flex justify-between w-full px-3 pt-3">
                                <div className="inputCheck">
                                    <input type="checkbox"/>
                                </div>
                                <div className="flex">
                                  <Skeleton />
                                </div>
                            </div>
                            <div className="cardHeader flex items-center pb-1 px-3">
                                <div className="logo w-[30px] rounded">
                                      <Skeleton />
                                </div>
                                <div className="Cardtitle w-3/4 pl-3">
                                <Skeleton />
                                </div>
                                <div className="iconsRight flex items-center">
                                <Skeleton />
                                </div>
                            </div>
                            <p></p>
                            <div className="cardContent cardListContent w-full">
                            <Skeleton />
                              </div>
                          </div>
                        <div className="px-3">
                        <Skeleton />
                          </div>
                          <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                          <Skeleton />
                            </div>
                            <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                            <Skeleton />
                              </div>
                      </div>
                      <div className="cardHolder rounded-[14px] overflow-hidden break-inside" style={{height:"330px"}}>
                      <div className="cardheight-content">
                            <div className="flex justify-between w-full px-3 pt-3">
                              <div className="inputCheck">
                                  <input type="checkbox"/>
                              </div>
                              <div className="flex">
                                <Skeleton />
                              </div>
                          </div>
                          <div className="cardHeader flex items-center pb-1 px-3">
                              <div className="logo w-[30px] rounded">
                                    <Skeleton />
                              </div>
                              <div className="Cardtitle w-3/4 pl-3">
                              <Skeleton />
                              </div>
                              <div className="iconsRight flex items-center">
                              <Skeleton />
                              </div>
                          </div>
                          <p></p>
                          <div className="cardContent cardListContent w-full">
                          <Skeleton />
                            </div>
                        </div>
                        <div className="px-3">
                        <Skeleton />
                          </div>
                          <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                          <Skeleton />
                            </div>
                            <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                            <Skeleton />
                              </div>
                      </div>
                      <div className="cardHolder rounded-[14px] overflow-hidden break-inside" style={{height:"330px"}}>
                      <div className="cardheight-content">
                            <div className="flex justify-between w-full px-3 pt-3">
                              <div className="inputCheck">
                                  <input type="checkbox"/>
                              </div>
                              <div className="flex">
                                <Skeleton />
                              </div>
                          </div>
                          <div className="cardHeader flex items-center pb-1 px-3">
                              <div className="logo w-[30px] rounded">
                                    <Skeleton />
                              </div>
                              <div className="Cardtitle w-3/4 pl-3">
                              <Skeleton />
                              </div>
                              <div className="iconsRight flex items-center">
                              <Skeleton />
                              </div>
                          </div>
                          <p></p>
                          <div className="cardContent cardListContent w-full">
                          <Skeleton />
                            </div>
                        </div>
                        <div className="px-3">
                        <Skeleton />
                          </div>
                          <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                          <Skeleton />
                            </div>
                            <div className="lastsection-subicon flex justify-between bg-[#F8F8F8] py-3 px-5 mt-1">
                            <Skeleton />
                              </div>
                      </div>
                  </Masonry>
              )} */}
            </div>
          )
      }
      {popup === true ? <CreateBucket bucketUpdate={bucketUpdate} bucketOperation={bucketOperation} parent={bucketId.id} setPopup={setPopup} /> : null}
      <ToastContainer />
    </>
  )
}

export default SharredCards;
